import React from 'react';
import { compose } from 'react-apollo';
import { withRouter } from 'react-router';
import AuthPage from './AuthPage';
import Login from './Login';
import Register from './Register';
import ForgetPassword from './ForgetPassword';

class Auth extends React.Component {
  // componentDidMount() {
  //   console.log('this.props.location', this.props.location);
  // }

  getFrom = () => {
    if (this.props.location.state && this.props.location.state.from) {
      return this.props.location.state.from;
    }

    return '';
  };

  redirectTo = () => {
    if (this.props.redirectTo) {
      return this.props.redirectTo;
    }

    return this.getFrom();
  };

  goTo = (page, e) => {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ contentFor: page });
    if (this.props.switchModalTo) {
      this.props.switchModalTo(page);
    }
  };

  content = () =>
    ({
      register: (
        <Register
          goTo={this.goTo}
          redirectTo={this.redirectTo()}
          handleClose={this.props.handleClose}
          isPage={this.props.isPage}
        />
      ),
      forgetpass: (
        <ForgetPassword
          goTo={this.goTo}
          redirectTo={this.redirectTo()}
          handleClose={this.props.handleClose}
          isPage={this.props.isPage}
        />
      ),
      login: (
        <Login
          goTo={this.goTo}
          redirectTo={this.redirectTo()}
          handleClose={this.props.handleClose}
          isPage={this.props.isPage}
        />
      ),
    }[this.props.contentFor || 'login']);

  render() {
    if (this.props.isPage) {
      return <AuthPage>{this.content()}</AuthPage>;
    }

    return this.content();
  }
}

export default compose(withRouter)(Auth);



// WEBPACK FOOTER //
// ./app/containers/Auth/index.js